import get from 'lodash-es/get';

import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import {
  getTravelCheckoutFormValues,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { getMessageKeyWithSuffix } from 'app/services/validation.service';

const formName = FormsEnum.TravelCheckoutForm;

const peselQuestionKeys = [
  FieldsEnum.TravelCheckoutTraveler1Pesel,
  FieldsEnum.TravelCheckoutTraveler2Pesel,
  FieldsEnum.TravelCheckoutTraveler3Pesel,
  FieldsEnum.TravelCheckoutTraveler4Pesel,
  FieldsEnum.TravelCheckoutTraveler5Pesel,
  FieldsEnum.TravelCheckoutTraveler6Pesel,
  FieldsEnum.TravelCheckoutTraveler7Pesel,
  FieldsEnum.TravelCheckoutTraveler8Pesel,
  FieldsEnum.TravelCheckoutTraveler9Pesel,
  FieldsEnum.TravelCheckoutTraveler10Pesel,
  FieldsEnum.TravelInsurantPesel,
];

function isPeselUnique(currentQuestionKey: FieldsEnum) {
  const formValues = getTravelCheckoutFormValues();
  const currentPesel = get(formValues, currentQuestionKey);
  const insurantSelection = get(
    formValues,
    FieldsEnum.TravelCheckoutContractSigner
  );
  const shouldSkipValidation = currentPesel?.includes('***');
  const isDifferentInsurantSelected = insurantSelection === 'different';

  if (shouldSkipValidation) {
    return true;
  }

  const peselsToCheck = isDifferentInsurantSelected
    ? peselQuestionKeys
    : peselQuestionKeys.filter(
        (questionKey) => questionKey !== FieldsEnum.TravelInsurantPesel
      );

  const isUnique = !peselsToCheck
    .filter((questionKey) => questionKey !== currentQuestionKey)
    .some((questionKey) => get(formValues, questionKey) === currentPesel);

  return isUnique;
}

function setPeselsUniqenessErrorsVisibility() {
  const formValues = getTravelCheckoutFormValues();
  const insurantSelection = get(
    formValues,
    FieldsEnum.TravelCheckoutContractSigner
  );
  const isDifferentInsurantSelected = insurantSelection === 'different';
  const peselsToCheck = isDifferentInsurantSelected
    ? peselQuestionKeys
    : peselQuestionKeys.filter(
        (questionKey) => questionKey !== FieldsEnum.TravelInsurantPesel
      );
  const peselsOccurrencesMap = new Map<string, number>();

  peselsToCheck.forEach((questionKey) => {
    const pesel = get(formValues, questionKey);
    const shouldSkipValidation = !pesel || pesel?.includes?.('***');

    if (shouldSkipValidation) {
      return;
    }

    peselsOccurrencesMap.set(pesel, (peselsOccurrencesMap.get(pesel) || 0) + 1);
  });

  peselQuestionKeys.forEach((questionKey) => {
    const pesel = get(formValues, questionKey);
    const shouldSkipValidation = !pesel || pesel?.includes?.('***');
    const isQuestionIncluded = peselsToCheck.includes(questionKey);
    const isPeselDuplicated =
      !shouldSkipValidation && (peselsOccurrencesMap.get(pesel) || 0) > 1;

    setMessageVisibility({
      key: getMessageKeyWithSuffix(questionKey, 'notUnique_pesel_short'),
      visible: isQuestionIncluded && isPeselDuplicated,
      formName,
    });
  });
}

export function validateTravelPeselUniqueness(currentQuestionKey: FieldsEnum) {
  const isCurrentPeselUnique = isPeselUnique(currentQuestionKey);

  setPeselsUniqenessErrorsVisibility();

  return isCurrentPeselUnique;
}
